import React, { useState } from "react";
import FormInput from "../../components/form-input/form-input.component";
import CustomButton from "../../components/custom-button/custom-button.component";
import "react-datepicker/dist/react-datepicker.css";
import "./questionnaire.styles.scss";
import apiClient from "../../app.service";
import { useHistory } from "react-router-dom";
import "react-multiple-select-dropdown-lite/dist/index.css";
import FileBase64 from "react-file-base64";
import { display } from "@mui/system";
import MultiSelect from "react-multiple-select-dropdown-lite";
import infoIcon from "../../assets/images/info-icon-svgrepo-com.svg";

const QuestionnaireFormComponent = (props) => {
  const history = useHistory();

  const [SystemType, setSystemType] = useState([]);
  const [HouseType, setHouseType] = useState([]);
  const [PermissionOption, setPermissionOption] = useState([]);
  const [SpecialInstructionOptions, setSpecialInstructionOptions] = useState(
    []
  );
  const [MountingStructureOption, setMountingStructureOption] = useState([]);
  const [SlopeRoofOption, setSlopeRoofOption] = useState([]);
  const [ShadeRoofOption, setShadeRoofOption] = useState([]);
  const [BackupDurationOption, setBackupDurationOption] = useState([]);
  const [TvWifiOption, setTvWifiOption] = useState([]);
  const [MicrowaveOption, setMicrowaveOption] = useState([]);
  const [FridgeOption, setFridgeOption] = useState([]);
  const [NumFridge, setNumFridge] = useState([]);
  const [LightsOption, setLightsOption] = useState([]);
  const [GateMotorOption, setGateMotorOption] = useState([]);
  const [AlarmSystemOption, setAlarmSystemOption] = useState([]);
  const [CameraSystemOption, setCameraSystemOption] = useState([]);
  const [StoveType, setStoveType] = useState([]);
  const [HobType, setHobType] = useState([]);
  const [NumGeysers, setNumGeysers] = useState([]);
  const [KettleType, setKettleType] = useState([]);
  const [NumFreezers, setNumFreezers] = useState([]);
  const [PoolMotorOption, setPoolMotorOption] = useState([]);
  const [BoreholesOption, setBoreholesOption] = useState([]);
  const [NumWashingMaching, setNumWashingMachine] = useState([]);
  const [NumDishWasher, setNumDishWasher] = useState([]);
  const [FloorHeatingOption, setFloorHeatingOption] = useState([]);
  // const [NumAirCon, setNumAirCon] = useState([]);
  const [NumPeople, setNumPeople] = useState([]);
  const [WorkDoneOption, setWorkDoneOption] = useState([]);
  const [GrannyFlatOption, setGrannyFlatOption] = useState([]);
  const [NumGarages, setNumGarages] = useState([]);
  const [ElecMain, setElecMain] = useState([]);
  const [ElecFlatlet, setElecFlatlet] = useState([]);
  const [AvgElec, setAvgElec] = useState([]);
  const [files, setFiles] = useState([]);

  const [message, setMessage] = useState("");

  const [questionnaire, setQuestionnaire] = useState({
    // "firstName":'',
    // "lastName":'',
    fullName:"",
    contactNumber:"",
    emailAddress: "",
    // "address":'',
    systemType: SystemType,
    houseType: "",
    permissionOption: "",
    specialInstructionsOption: "",
    mountingStructureOption: "",
    slopeRoofOption: "",
    shadeRoofOption: "",
    backupDurationOption: "",
    tvWifiOption: "",
    microwaveOption: "",
    tvMicrowaveTotalWattage: "0",
    fridgeOption: "",
    numFridge: "",
    fridgeTotalWattage: "0",
    lightsOption: "",
    lightsTotalWattage: "0",
    gateMotorOption: "",
    gateMotorTotalWattage: "0",
    alarmSystemOption: "",
    alarmSystemTotalWattage: "0",
    cameraSystemOption: "",
    cameraSystemTotalWattage: "0",
    stoveType: "",
    hobType: "",
    numGeysers: "",
    kettleType: "",
    numFreezers: "",
    freezerTotalWattage: "0",
    poolMotorOption: "",
    poolMotorTotalWattage: "0",
    boreholesOption: "",
    boreholesTotalWattage: "0",
    numWashingMachine: "",
    washingMachineTotalWattage: "0",
    numDishWasher: "",
    dishWasherTotalWattage: "0",
    floorHeatingOption: "",
    floorHeatingTotalWattage: "0",
    // numAirCon: "",
    // airConTotalWattage: "0",
    numPeople: "",
    workDoneOption: "",
    workDoneTotalWattage: "0",
    grannyFlatOption: "",
    numGarages: "",
    elecMain: "",
    elecFlatlet: "",
    avgElec: "",
    files: "",
    totalWattageSummation: "",
    microwaveTotalWattage: "0",
    electricStoveTotalWattage: "0",
    electricHobTotalWattage: "0",
    geysersTotalWattage: "0",
    electricKettleTotalWattage: "0", 
    numGaragesTotalWattage: "0"
  });

  const getFiles = (files) => {
    setFiles(files);
  };

  const [selected, setSelected] = useState([]);

  const systemTypeOption = [
    {
      value: "Uninterrupted power supply (UPS)",
      label: "Uninterrupted power supply (UPS)",
    },
    {
      value: "Grid-tied system",
      label: "Grid-tied system",
    },
    {
      value: "Hybrid system",
      label: "Hybrid system",
    },
    {
      value: "Going off-grid",
      label: "Going off-grid",
    },
    {
      value: "Still unsure",
      label: "Still unsure",
    },
  ];

  const houseType = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const permissionOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
    {
      value: "N/A",
      label: "N/A",
    },
  ];

  const specialInstructionsOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
    {
      value: "N/A",
      label: "N/A",
    },
  ];

  const mountingStructureOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Concrete Roof",
      label: "Concrete Roof",
    },
    {
      value: "Corrugated Roof",
      label: "Corrugated Roof",
    },
    {
      value: "Tiled Roof",
      label: "Tiled Roof",
    },
    {
      value: "Ground Mounting",
      label: "Ground Mounting",
    },
    {
      value: "Carport (Existing)",
      label: "Carport (Existing)",
    },
    {
      value: "Carport (Installation)",
      label: "Carport (Installation)",
    },
  ];

  const slopeRoofOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Flat",
      label: "Flat",
    },
    {
      value: "10 degrees",
      label: "10 degrees",
    },
    {
      value: "25+ degrees",
      label: "25+ degrees",
    },
  ];

  const shadeRoofOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "None",
      label: "None",
    },
    {
      value: "Minimal",
      label: "Minimal",
    },
    {
      value: "Heavy",
      label: "Heavy",
    },
  ];

  const backupDurationOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "2 to 4 hours",
      label: "2 to 4 hours",
    },
    {
      value: "5+ hours",
      label: "5+ hours",
    },
  ];

  const tvWifiOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const microwaveOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const fridgeOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const numFridge = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "1 to 2",
      label: "1 to 2",
    },
    {
      value: "3+",
      label: "3+",
    },
  ];

  const lightsOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const gateMotorOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const alarmSystemOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const cameraSystemOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const stoveType = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Electric",
      label: "Electric",
    },
    {
      value: "Gas",
      label: "Gas",
    },
  ];

  const hobType = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Electric",
      label: "Electric",
    },
    {
      value: "Gas",
      label: "Gas",
    },
  ];

  const numGeysers = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "1",
      label: "1",
    },
    {
      value: "2+",
      label: "2+",
    },
  ];

  const kettleType = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Electric",
      label: "Electric",
    },
    {
      value: "Gas",
      label: "Gas",
    },
  ];

  const numFreezers = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "1",
      label: "1",
    },
    {
      value: "2+",
      label: "2+",
    },
  ];

  const poolMotorOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const boreholesOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const numWashingMachine = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "1",
      label: "1",
    },
    {
      value: "2+",
      label: "2+",
    },
  ];

  const numDishWasher = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "1",
      label: "1",
    },
    {
      value: "2+",
      label: "2+",
    },
  ];

  const floorHeatingOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  // const numAirCon = [
  //   {
  //     value: "",
  //     label: "Select an option",
  //   },
  //   {
  //     value: "1 to 2",
  //     label: "1 to 2",
  //   },
  //   {
  //     value: "3+",
  //     label: "3+",
  //   },
  // ];

  const numPeople = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "1",
      label: "1",
    },
    {
      value: "2",
      label: "2",
    },
    {
      value: "3+",
      label: "3+",
    },
  ];

  const workDoneOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const grannyFlatOption = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const numGarages = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "0",
      label: "0",
    },
    {
      value: "1",
      label: "1",
    },
    {
      value: "2+",
      label: "2+",
    },
  ];

  const elecMain = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const elecFlatlet = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const avgElec = [
    {
      value: "",
      label: "Select an option",
    },
    {
      value: "R500 to R1200",
      label: "R500 to R1200",
    },
    {
      value: "R1200 to R2000",
      label: "R1200 to R2000",
    },
    {
      value: "R2000 to R3000",
      label: "R2000 to R3000",
    },
    {
      value: "R3000 to R5000",
      label: "R3000 to R5000",
    },
    {
      value: "R5000+",
      label: "R5000+",
    },
  ];

  const handleAddFiles = (files) => {
    // setFiles(files);
    const mergeFiles = files.concat(files);
    setFiles(mergeFiles);
    console.log("Files update: ", mergeFiles);
    setQuestionnaire({ ...questionnaire, files: files.target.value });
  };

  // const handleSystemTypeChange = (systemType) => {
  //     setSystemType(systemType.target.value);
  //     setQuestionnaire({...questionnaire,systemType:systemType.target.value});

  //     }

  // const handleSystemTypeChange = (val) => {
  //   SystemType.push(val);

  //   setQuestionnaire({ ...questionnaire, systemType: SystemType });
  //   console.log("System type :", questionnaire.systemType)
  // };

  const handleHouseTypeChange = (houseType) => {
    setHouseType(houseType.target.value);
    setQuestionnaire({ ...questionnaire, houseType: houseType.target.value });
  };

  const handlePermissionOptionChange = (permissionOption) => {
    setPermissionOption(permissionOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      permissionOption: permissionOption.target.value,
    });
  };

  const handleSpecialInstructionsOptionChange = (specialInstructionsOption) => {
    setSpecialInstructionOptions(specialInstructionsOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      specialInstructionsOption: specialInstructionsOption.target.value,
    });
  };

  const handleMountingStructureOptionChange = (mountingStructureOption) => {
    setMountingStructureOption(mountingStructureOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      mountingStructureOption: mountingStructureOption.target.value,
    });
  };

  const handleSlopeRoofOptionChange = (slopeRoofOption) => {
    setSlopeRoofOption(slopeRoofOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      slopeRoofOption: slopeRoofOption.target.value,
    });
  };

  const handleShadeRoofOptionChange = (shadeRoofOption) => {
    setShadeRoofOption(shadeRoofOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      shadeRoofOption: shadeRoofOption.target.value,
    });
  };

  const handlebackupDurationOptionChange = (backupDurationOption) => {
    setBackupDurationOption(backupDurationOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      backupDurationOption: backupDurationOption.target.value,
    });
  };

  const handleTvWifiOptionChange = (tvWifiOption) => {
    setTvWifiOption(tvWifiOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      tvWifiOption: tvWifiOption.target.value,
    });
  };

  const handleMicrowaveOptionChange = (microwaveOption) => {
    setMicrowaveOption(microwaveOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      microwaveOption: microwaveOption.target.value,
    });
  };

  const handleFridgeOptionChange = (fridgeOption) => {
    setFridgeOption(fridgeOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      fridgeOption: fridgeOption.target.value,
    });
  };

  const handleNumFridgeChange = (numFridge) => {
    setNumFridge(numFridge.target.value);
    setQuestionnaire({ ...questionnaire, numFridge: numFridge.target.value });
  };

  const handleLightsOptionChange = (lightsOption) => {
    setLightsOption(lightsOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      lightsOption: lightsOption.target.value,
    });
  };

  const handleGateMotorOptionChange = (gateMotorOption) => {
    setGateMotorOption(gateMotorOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      gateMotorOption: gateMotorOption.target.value,
    });
  };

  const handleAlarmSystemOptionChange = (alarmSystemOption) => {
    setAlarmSystemOption(alarmSystemOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      alarmSystemOption: alarmSystemOption.target.value,
    });
  };

  const handleCameraSystemOptionChange = (cameraSystemOption) => {
    setCameraSystemOption(cameraSystemOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      cameraSystemOption: cameraSystemOption.target.value,
    });
  };

  const handleStoveTypeChange = (stoveType) => {
    setStoveType(stoveType.target.value);
    setQuestionnaire({ ...questionnaire, stoveType: stoveType.target.value });
  };

  const handleHobTypeChange = (hobType) => {
    setHobType(hobType.target.value);
    setQuestionnaire({ ...questionnaire, hobType: hobType.target.value });
  };

  const handleNumGeysersChange = (numGeysers) => {
    setNumGeysers(numGeysers.target.value);
    setQuestionnaire({ ...questionnaire, numGeysers: numGeysers.target.value });
  };

  const handleKettleTypeChange = (kettleType) => {
    setKettleType(kettleType.target.value);
    setQuestionnaire({ ...questionnaire, kettleType: kettleType.target.value });
  };

  const handleNumFreezersChange = (numFreezers) => {
    setNumFreezers(numFreezers.target.value);
    setQuestionnaire({
      ...questionnaire,
      numFreezers: numFreezers.target.value,
    });
  };

  const handlePoolMotorOptionChange = (poolMotorOption) => {
    setPoolMotorOption(poolMotorOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      poolMotorOption: poolMotorOption.target.value,
    });
  };

  const handleBoreholesOptionChange = (boreholesOption) => {
    setBoreholesOption(boreholesOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      boreholesOption: boreholesOption.target.value,
    });
  };

  const handleNumWashingMachineChange = (numWashingMachine) => {
    setNumWashingMachine(numWashingMachine.target.value);
    setQuestionnaire({
      ...questionnaire,
      numWashingMachine: numWashingMachine.target.value,
    });
  };

  const handleNumDishWasherChange = (numDishWasher) => {
    setNumDishWasher(numDishWasher.target.value);
    setQuestionnaire({
      ...questionnaire,
      numDishWasher: numDishWasher.target.value,
    });
  };

  const handleFloorHeatingOptionChange = (floorHeatingOption) => {
    setFloorHeatingOption(floorHeatingOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      floorHeatingOption: floorHeatingOption.target.value,
    });
  };

  // const handleNumAirConChange = (numAirCon) => {
  //   setNumAirCon(numAirCon.target.value);
  //   setQuestionnaire({ ...questionnaire, numAirCon: numAirCon.target.value });
  // };

  const handleNumPeopleChange = (numPeople) => {
    setNumPeople(numPeople.target.value);
    setQuestionnaire({ ...questionnaire, numPeople: numPeople.target.value });
  };

  const handleWorkDoneOptionChange = (workDoneOption) => {
    setWorkDoneOption(workDoneOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      workDoneOption: workDoneOption.target.value,
    });
  };

  const handleGrannyFlatOptionChange = (grannyFlatOption) => {
    setGrannyFlatOption(grannyFlatOption.target.value);
    setQuestionnaire({
      ...questionnaire,
      grannyFlatOption: grannyFlatOption.target.value,
    });
  };

  const handleNumGaragesChange = (numGarages) => {
    setNumGarages(numGarages.target.value);
    setQuestionnaire({ ...questionnaire, numGarages: numGarages.target.value });
  };

  const handleElecMainChange = (elecMain) => {
    setElecMain(elecMain.target.value);
    setQuestionnaire({ ...questionnaire, elecMain: elecMain.target.value });
  };

  const handleElecFlatletChange = (elecFlatlet) => {
    setElecFlatlet(elecFlatlet.target.value);
    setQuestionnaire({
      ...questionnaire,
      elecFlatlet: elecFlatlet.target.value,
    });
  };

  const handleAvgElecChange = (avgElec) => {
    setAvgElec(avgElec.target.value);
    setQuestionnaire({ ...questionnaire, avgElec: avgElec.target.value });
  };

  const handleChange = (name) => (e) => {
    // console.log("Event: ", e)
    setQuestionnaire({ ...questionnaire, [name]: e.target.value });
    //   this.setState({ [name]: value })
  };

  const handleCellphoneChange = (name) => (e) => {
    // console.log("Event: ", e)
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setQuestionnaire({ ...questionnaire, [name]: e.target.value });
      //   this.setState({ [name]: value })
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    questionnaire.systemType = selected;

    setMessage("Submitting questionnaire...");

    setQuestionnaire(
      (questionnaire.totalWattageSummation =
        parseFloat(questionnaire.tvMicrowaveTotalWattage) +
        parseFloat(questionnaire.fridgeTotalWattage) +
        parseFloat(questionnaire.lightsTotalWattage) +
        parseFloat(questionnaire.gateMotorTotalWattage) +
        parseFloat(questionnaire.alarmSystemTotalWattage) +
        parseFloat(questionnaire.cameraSystemTotalWattage) +
        parseFloat(questionnaire.freezerTotalWattage) +
        parseFloat(questionnaire.poolMotorTotalWattage) +
        parseFloat(questionnaire.boreholesTotalWattage) +
        parseFloat(questionnaire.washingMachineTotalWattage) +
        parseFloat(questionnaire.dishWasherTotalWattage) +
        parseFloat(questionnaire.floorHeatingTotalWattage) +
        // parseFloat(questionnaire.airConTotalWattage) +
        parseFloat(questionnaire.workDoneTotalWattage) +

        parseFloat(questionnaire.microwaveTotalWattage)+
        parseFloat(questionnaire.electricStoveTotalWattage)+
        parseFloat(questionnaire.electricHobTotalWattage)+ 
        parseFloat(questionnaire.geysersTotalWattage)+
        parseFloat(questionnaire.electricKettleTotalWattage) +
        parseFloat(questionnaire.numGaragesTotalWattage)
        )
    );

    console.log("Questionnaire", questionnaire);

    apiClient.createQuestionnaire(questionnaire).then((res) => {
      // console.log("res", res)
      if (res.result === "success") {
        const newMessage = "Thank you for your feedback.";
        setMessage(newMessage);
        setTimeout(() => {
          history.push({
            pathname: "/",
            // state: props.location.state
          });
        }, 1000);
      }
    });
  };
  const num = <a href="tel:0637990137">063 7990 137</a>;
  const link = (
    <a href="mailto:voltex-asolar@voltex.co.za">voltex-asolar@voltex.co.za</a>
  );
  return message !== "" ? (
    <center>
      {" "}
      <div>
        {message.split("\n").map((e) => (
          <h2>{e}</h2>
        ))}
        {"Feel free to give us a call if you have any questions."}
        <br />
        {"Call: "}
        {num}
        <br />
        {"Email: "}
        {link}
      </div>{" "}
    </center>
  ) : (
    <div className="questionnaire">
      <h1 className="title" align="center">
        Voltex Solar Customer Questionnaire
      </h1>
      <p align="center">Please fill out this questionnaire. </p>
      {/* <br></br>Your valuable feedback helps us improve our service. */}
      <br></br>
      <br></br>
      <div className="container">
        <form className="questionnaireForm" onSubmit={handleSubmit}>
          <div className="">
            <h2>1. Personal Details</h2>
              <p>
                Full Name:<div className="required">*</div>{" "}
              </p>
              <input
                className="input"
                type="text"
                value={questionnaire.fullName || ""}
                onChange={handleChange("fullName")}
                required
              ></input>
              <p>
                Email Address:<div className="required">*</div>{" "}
              </p>
              <input
                className="input"
                type="email"
                value={questionnaire.emailAddress || ""}
                onChange={handleChange("emailAddress")}
                required
              ></input>
              <br />
              <p>
                Contact Number:<div className="required">*</div>{" "}
              </p>
              <input
                className="input"
                type="text"
                value={questionnaire.contactNumber || ""}
                onChange={handleChange("contactNumber")}
                required
              ></input>
          </div>
          <br />

          <div className="">
            <h2>2. TYPE OF SYSTEM REQUIRED</h2>

              <p>
                Type of system required.<div className="required">*</div>{" "}
              </p>

              <div className="inline">
              <MultiSelect
              // className="MultiSelect"
              id="systemTypeDropdown"
              // type='dropdown'
              // name='offerDropdown'
              // value={questionnaire.systemType}
              onChange={setSelected}
              options={systemTypeOption}
              value={selected}
              labelledBy="Select"
              // placeholder="Select an Option"
              required
            />
            &nbsp;&nbsp;
            <div class="tooltip">
                <img src={infoIcon} width="20px" />
                <span class="tooltiptext">
                  <p>
                    <h3>Uninterrupted power supply (UPS):</h3>
                     A UPS solution allows you to store energy from the grid and use it when there are power outages.
                     There are plug-and-play solutions that you can purchase from local retail stores. 
                     Alternatively, you can have an accredited installer set up the solution according to your 
                     household consumption requirements. This solution does not save you energy costs, but offers 
                     resilience to load shedding and power outages, helping to keep the lights on.
                  </p>
                  
                  <p>
                    <h3>Grid-tied system:</h3>
                    A grid-tied system is the most common solar system. It consists of solar panels and an inverter. 
                    The system uses panels installed on your roof to convert sunlight to electricity (DC). Inverters 
                    convert this electricity to a form usable in your household (AC). This energy will be available for as 
                    long as there is sunlight and any extra energy generated from the sun will be lost due to a battery not 
                    being added to the solution. This solution will also not produce electricity during load shedding.
                  </p>
                  
                  <p>
                    <h3>Hybrid system:</h3>
                    If you are looking at a solution that keeps your lights on during load shedding, the hybrid solution is an
                     option to consider. This solution adds batteries to your solar system and allows you to store any surplus
                      energy to use during power outages or when there is no energy generated from the solar panels (at night).
                  </p>
                 
                  <p>
                    <h3>Going off grid:</h3>
                    An off-grid solution means energy independence, i.e. disconnecting all supply connections from the utility 
                    and relying only on the electricity being generated by your solar system. You would need to consider other 
                    alternatives such as using a solar geyser, a gas stove, a gas heater, etc. Your battery capacity and the size 
                    of your solution may not be strong enough to power high-wattage appliances.
                  </p>
                </span>
            </div>
              </div>
              
            {/* <pre>{JSON.stringify(selected)}</pre> */}
            
          </div>
          {<br />}

          {selected == "Uninterrupted power supply (UPS)" ? (
            <div>
              <div className="row">
                <h2>4. DURATION OF BACK-UP / SOLAR POWER REQUIRED</h2>
                <p>Time required:*</p>

                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.backupDurationOption}
                  onChange={handlebackupDurationOptionChange}
                  required
                >
                  {backupDurationOption.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <br />
              </div>
              {<br />}
              <div className="loadRequired">
                <h2>5. LOAD REQUIRED</h2>
                <p>(Essential load you would like to add to your system)</p>
                <h4>Essential Items</h4>
                <div className="essential1">
                  <p>5.1 Tv & Wifi:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.tvWifiOption}
                    onChange={handleTvWifiOptionChange}
                    // required
                  >
                    {tvWifiOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />

                  {questionnaire.tvWifiOption === "Yes" ? (
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.tvMicrowaveTotalWattage || ""}
                        onChange={handleChange("tvMicrowaveTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.tvMicrowaveTotalWattage = 0), "")
                  )}
                </div>

                <br />

                <div className="essential3">
                  <p>5.4 Lights: (recommended to be LED)</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.lightsOption}
                    onChange={handleLightsOptionChange}
                    // required
                  >
                    {lightsOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {questionnaire.lightsOption === "Yes" ? (
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.lightsTotalWattage || ""}
                        onChange={handleChange("lightsTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.lightsTotalWattage = 0), "")
                  )}
                </div>

                <br />
              </div>
            </div>
          ) : (
            <div>
              <div className="">
                <h2>3. PANELS REQUIRED</h2>
                <p>
                  3.1 Is your house in a complex?
                  <div className="required">*</div>{" "}
                </p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.houseType}
                  onChange={handleHouseTypeChange}
                  required
                >
                  {houseType.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <br />

                {
                  questionnaire.houseType == "Yes"
                  ?
                  <div>
                    
                    <p>
                  3.2 Do you have permission from your landlord / body corporate
                  to install solar panels on your roof?
                  <div className="required">*</div>{" "}
                </p>
                    <div className="inline">
                    <select
                      className="dropdown"
                      type="dropdown"
                      name="offerDropdown"
                      value={questionnaire.permissionOption}
                      onChange={handlePermissionOptionChange}
                      required
                    >
                      {permissionOption.map((option, index) => (
                        <option value={option.value} key={index}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    &nbsp;&nbsp;
                        <div class="tooltip">
                        <img src={infoIcon} width="20px" />
                        <span class="tooltiptext">
                        <h5>
                        If a prior decision has not been made by the Landlord or Body Corporate, Tenants or Sectional Title Owners must ensure that the necessary approvals are obtained before work is commenced from the Owner or Body Corporate.
                        </h5>
                        </span>
                        </div>
                    </div>

                    <br />
                <p>
                  3.3 Does your landlord / body corporate have special installation instructions
                  that could alter the cost of the quotation?
                  <div className="required">*</div>{" "}
                </p>

                <div className="inline">
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.specialInstructionsOption}
                    onChange={handleSpecialInstructionsOptionChange}
                    required
                  >
                    {specialInstructionsOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>

                  &nbsp;&nbsp;
                        <div class="tooltip">
                        <img src={infoIcon} width="20px" />
                        <span class="tooltiptext">
                        <h5>
                        Landlords / Body corporates could request that the solar panels must be
                         black or charcoal colour to match the roof and that the solar panel 
                         frame and the mounting structure matches the colour of the solar
                        panel. <br /><br />The standard colour of the solar panel frame and mounting 
                        structure is aluminium silver.
                        </h5>
                        </span>
                        </div>

                </div>

                  </div>
                  :
                  ""
                }
                

                

                {questionnaire.specialInstructionsOption === "Yes" ? (
                  <div>
                    <p>
                      If yes, please specify type of mounting structure?
                      <div className="required">*</div>{" "}
                    </p>
                    <select
                      className="dropdown"
                      type="dropdown"
                      name="offerDropdown"
                      value={questionnaire.mountingStructureOption}
                      onChange={handleMountingStructureOptionChange}
                      required
                    >
                      {mountingStructureOption.map((option, index) => (
                        <option value={option.value} key={index}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : (
                  ""
                )}

                {questionnaire.mountingStructureOption ===
                "Carport (Existing)" ? (
                  <div>
                    {/* <p>If yes, please specify type of mounting structure:</p> */}
                    <p>
                      What is the Slope of roof<div className="required">*</div>{" "}
                    </p>
                    <select
                      className="dropdown"
                      type="dropdown"
                      name="offerDropdown"
                      value={questionnaire.slopeRoofOption}
                      onChange={handleSlopeRoofOptionChange}
                      required
                    >
                      {slopeRoofOption.map((option, index) => (
                        <option value={option.value} key={index}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <br />
                    <p>
                      What is the Shading of roof
                      <div className="required">*</div>{" "}
                    </p>
                    <select
                      className="dropdown"
                      type="dropdown"
                      name="offerDropdown"
                      value={questionnaire.shadeRoofOption}
                      onChange={handleShadeRoofOptionChange}
                      required
                    >
                      {shadeRoofOption.map((option, index) => (
                        <option value={option.value} key={index}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : (
                  ""
                )}
                <br />
              </div>
              <br />

              <div className="">
                <h2>4. DURATION OF BACK-UP / SOLAR POWER REQUIRED</h2>
                <p>Time required:*</p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.backupDurationOption}
                  onChange={handlebackupDurationOptionChange}
                  required
                >
                  {backupDurationOption.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <br />
              </div>
              {<br />}

              <div className="">
                <h2>5. LOAD REQUIRED</h2>
                <h5>(Essential load you would like to add to your system)</h5>
                <h4>Essential Items</h4>
                <div className="essential1">
                  <p>5.1 Tv & Wifi:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.tvWifiOption}
                    onChange={handleTvWifiOptionChange}
                    // required
                  >
                    {tvWifiOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />

                  {
                    questionnaire.tvWifiOption === "Yes"
                    ?
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.tvMicrowaveTotalWattage || ""}
                        onChange={handleChange("tvMicrowaveTotalWattage")}
                        // required
                      ></input>
                    </div>
                    :
                    ((questionnaire.tvMicrowaveTotalWattage = 0), "")
                  }

                  <p>5.2 Microwave:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.microwaveOption}
                    onChange={handleMicrowaveOptionChange}
                    // required
                  >
                    {microwaveOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {questionnaire.microwaveOption === "Yes"  ? (
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.microwaveTotalWattage || ""}
                        onChange={handleChange("microwaveTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.microwaveTotalWattage = 0), "")
                  )}
                </div>

                <br />
                <div className="essential2">
                  <p>5.3 Fridge:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.fridgeOption}
                    onChange={handleFridgeOptionChange}
                    // required
                  >
                    {fridgeOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />

                  {questionnaire.fridgeOption === "Yes" ? (
                    <div>
                      <p>Number of fridges & freezers:</p>
                      <select
                        className="dropdown"
                        type="dropdown"
                        name="offerDropdown"
                        value={questionnaire.numFridge}
                        onChange={handleNumFridgeChange}
                        // required
                      >
                        {numFridge.map((option, index) => (
                          <option value={option.value} key={index}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.fridgeTotalWattage || ""}
                        onChange={handleChange("fridgeTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.fridgeTotalWattage = 0), "")
                  )}
                </div>

                <br />

                <p>5.4 Lights: (recommended to be LED)</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.lightsOption}
                    onChange={handleLightsOptionChange}
                    // required
                  >
                    {lightsOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {questionnaire.lightsOption === "Yes" ? (
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.lightsTotalWattage || ""}
                        onChange={handleChange("lightsTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.lightsTotalWattage = 0), "")
                  )}

                <br />

                <div className="essential4">
                  <p>5.5 Gate Motor:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.gateMotorOption}
                    onChange={handleGateMotorOptionChange}
                    // required
                  >
                    {gateMotorOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {questionnaire.gateMotorOption === "Yes" ? (
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.gateMotorTotalWattage || ""}
                        onChange={handleChange("gateMotorTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.gateMotorTotalWattage = 0), "")
                  )}
                </div>

                <br />

                <div className="essential5">
                  <p>5.6 Alarm System: (Incl Electric Fencing)</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.alarmSystemOption}
                    onChange={handleAlarmSystemOptionChange}
                    // required
                  >
                    {alarmSystemOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {questionnaire.alarmSystemOption === "Yes" ? (
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.alarmSystemTotalWattage || ""}
                        onChange={handleChange("alarmSystemTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.alarmSystemTotalWattage = 0), "")
                  )}
                </div>

                <br />

                <div className="essential6">
                  <p>5.7 Camera System:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.cameraSystemOption}
                    onChange={handleCameraSystemOptionChange}
                    // required
                  >
                    {cameraSystemOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {questionnaire.cameraSystemOption === "Yes" ? (
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.cameraSystemTotalWattage || ""}
                        onChange={handleChange("cameraSystemTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.cameraSystemTotalWattage = 0), "")
                  )}
                </div>

                <br />
                <h4>Non-Essential Items</h4>

                <div className="non-essential1">
                  <p>5.8 Type of Stove:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.stoveType}
                    onChange={handleStoveTypeChange}
                    // required
                  >
                    {stoveType.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />

                  {
                    questionnaire.stoveType === "Electric"
                    ?
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.electricStoveTotalWattage || ""}
                        onChange={handleChange("electricStoveTotalWattage")}
                        // required
                      ></input>
                    </div>
                    :
                    ((questionnaire.electricStoveTotalWattage = 0), "")
                  }

                </div>

                <br />

                <div className="non-essential2">
                  <p>5.9 Type of Hob:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.hobType}
                    onChange={handleHobTypeChange}
                    // required
                  >
                    {hobType.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {
                    questionnaire.hobType === "Electric"
                    ?
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.electricHobTotalWattage || ""}
                        onChange={handleChange("electricHobTotalWattage")}
                        // required
                      ></input>
                    </div>
                    :
                    ((questionnaire.electricHobTotalWattage = 0), "")
                  }
                </div>

                <br />

                <div className="non-essential3">
                  <p>5.10 Number of Geysers:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.numGeysers}
                    onChange={handleNumGeysersChange}
                    // required
                  >
                    {numGeysers.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {
                    questionnaire.numGeysers !== ""
                    ?
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.geysersTotalWattage || ""}
                        onChange={handleChange("geysersTotalWattage")}
                        // required
                      ></input>
                    </div>
                    :
                    ((questionnaire.geysersTotalWattage = 0), "")
                  }
                </div>
                <br />

                <div className="non-essential4">
                  <p>5.11 Type of Kettle:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.kettleType}
                    onChange={handleKettleTypeChange}
                    // required
                  >
                    {kettleType.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {
                    questionnaire.kettleType === "Electric" 
                    ?
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.electricKettleTotalWattage || ""}
                        onChange={handleChange("electricKettleTotalWattage")}
                        // required
                      ></input>
                    </div>
                    :
                    ((questionnaire.electricKettleTotalWattage = 0), "")
                  }
                </div>

                <br />

                <div className="non-essential5">
                  <p>5.12 Freezers:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.numFreezers}
                    onChange={handleNumFreezersChange}
                    // required
                  >
                    {numFreezers.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                  {questionnaire.numFreezers !== "" ? (
                    <div>
                      <p>Total Wattage: (in Watts)</p>
                      <input
                        className="input"
                        type="number"
                        value={questionnaire.freezerTotalWattage || ""}
                        onChange={handleChange("freezerTotalWattage")}
                        // required
                      ></input>
                    </div>
                  ) : (
                    ((questionnaire.freezerTotalWattage = 0), "")
                  )}
                </div>

                <br />

                <div className="non-essential6">
                  <p>5.13 Pool Motor:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.poolMotorOption}
                    onChange={handlePoolMotorOptionChange}
                    // required
                  >
                    {poolMotorOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                </div>

                {questionnaire.poolMotorOption === "Yes" ? (
                  <div>
                    <p>Total Wattage: (in Watts)</p>
                    <input
                      className="input"
                      type="number"
                      value={questionnaire.poolMotorTotalWattage || ""}
                      onChange={handleChange("poolMotorTotalWattage")}
                      required
                    ></input>
                  </div>
                ) : (
                  ((questionnaire.poolMotorTotalWattage = 0), "")
                )}

                <br />

                <div className="non-essential7">
                  <p>5.14 Boreholes:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.boreholesOption}
                    onChange={handleBoreholesOptionChange}
                    // required
                  >
                    {boreholesOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                </div>

                {questionnaire.boreholesOption === "Yes" ? (
                  <div>
                    <p>Total Wattage: (in Watts)</p>
                    <input
                      className="input"
                      type="number"
                      value={questionnaire.boreholesTotalWattage || ""}
                      onChange={handleChange("boreholesTotalWattage")}
                      // required
                    ></input>
                  </div>
                ) : (
                  ((questionnaire.boreholesTotalWattage = 0), "")
                )}

                <br />

                <div className="non-essential8">
                  <p>5.15 Washing Machine: (total for property)</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.numWashingMachine}
                    onChange={handleNumWashingMachineChange}
                    // required
                  >
                    {numWashingMachine.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                </div>

                {questionnaire.numWashingMachine !== "" ? (
                  <div>
                    <p>Total Wattage: (in Watts)</p>
                    <input
                      className="input"
                      type="number"
                      value={questionnaire.washingMachineTotalWattage || ""}
                      onChange={handleChange("washingMachineTotalWattage")}
                      // required
                    ></input>
                  </div>
                ) : (
                  ((questionnaire.washingMachineTotalWattage = 0), "")
                )}

                <br />

                <div className="non-essential9">
                  <p>5.16 Dish Washer:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.numDishWasher}
                    onChange={handleNumDishWasherChange}
                    // required
                  >
                    {numDishWasher.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                </div>

                {questionnaire.numDishWasher !== "" ? (
                  <div>
                    <p>Total Wattage: (in Watts)</p>
                    <input
                      className="input"
                      type="number"
                      value={questionnaire.dishWasherTotalWattage || ""}
                      onChange={handleChange("dishWasherTotalWattage")}
                      // required
                    ></input>
                  </div>
                ) : (
                  ((questionnaire.dishWasherTotalWattage = 0), "")
                )}

                <br />

                <div className="non-essential10">
                  <p>5.17 Underfloor Heating:</p>
                  <select
                    className="dropdown"
                    type="dropdown"
                    name="offerDropdown"
                    value={questionnaire.floorHeatingOption}
                    onChange={handleFloorHeatingOptionChange}
                    // required
                  >
                    {floorHeatingOption.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <br />
                </div>

                {questionnaire.floorHeatingOption === "Yes" ? (
                  <div>
                    <p>Total Wattage: (in Watts)</p>
                    <input
                      className="input"
                      type="number"
                      value={questionnaire.floorHeatingTotalWattage || ""}
                      onChange={handleChange("floorHeatingTotalWattage")}
                      // required
                    ></input>
                  </div>
                ) : (
                  ((questionnaire.floorHeatingTotalWattage = 0), "")
                )}

                <br />
              </div>

              <div className="">
                <h2>6. OCCUPANTS</h2>
                <p>
                  6.1 Number of people home based / Working from home:
                  <div className="required">*</div>{" "}
                </p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.numPeople}
                  onChange={handleNumPeopleChange}
                  required
                >
                  {numPeople.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <br />
                <br />

                <p>
                  6.2 Is any work being done that requires the use of electrical
                  equipment besides essential products:
                  <div className="required">*</div>{" "}
                </p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.workDoneOption}
                  onChange={handleWorkDoneOptionChange}
                  required
                >
                  {workDoneOption.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>

                {questionnaire.workDoneOption === "Yes" ? (
                  <div>
                    <p>
                      Total Wattage: (in Watts)<div className="required">*</div>{" "}
                    </p>
                    <input
                      className="input"
                      type="number"
                      value={questionnaire.workDoneTotalWattage || ""}
                      onChange={handleChange("workDoneTotalWattage")}
                      required
                    ></input>
                  </div>
                ) : (
                  ((questionnaire.workDoneTotalWattage = 0), "")
                )}
                <br />
                <br />

                <p>
                  6.3 Do you have a granny flat/flatlet:
                  <div className="required">*</div>{" "}
                </p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.grannyFlatOption}
                  onChange={handleGrannyFlatOptionChange}
                  required
                >
                  {grannyFlatOption.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>

                <br />
                <br />

                <p>
                  6.4 Number of Garages:<div className="required">*</div>{" "}
                </p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.numGarages}
                  onChange={handleNumGaragesChange}
                  required
                >
                  {numGarages.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>

                {questionnaire.numGarages === "1" || questionnaire.numGarages === "2+"  ? (
                  <div>
                    <p>
                      Total Wattage: (in Watts)<div className="required">*</div>{" "}
                    </p>
                    <input
                      className="input"
                      type="number"
                      value={questionnaire.numGaragesTotalWattage || ""}
                      onChange={handleChange("numGaragesTotalWattage")}
                      required
                    ></input>
                  </div>
                ) : (
                  ((questionnaire.numGaragesTotalWattage = 0), "")
                )}
                <br />
                <br />

              </div>
              <br />

              <div className="">
                <h2>7. ELECTRICAL SUPPLY</h2>
                <p>
                  7.1 Is your electrical supply prepaid on main house:
                  <div className="required">*</div>{" "}
                </p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.elecMain}
                  onChange={handleElecMainChange}
                  required
                >
                  {elecMain.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <br />
                <br />
                {questionnaire.grannyFlatOption === "Yes" ? (
                  <>
                    <p>
                      7.2 Is your electrical supply prepaid on flatlet / granny
                      flat:
                    </p>
                    <select
                      className="dropdown"
                      type="dropdown"
                      name="offerDropdown"
                      value={questionnaire.elecFlatlet}
                      onChange={handleElecFlatletChange}
                    >
                      {elecFlatlet.map((option, index) => (
                        <option value={option.value} key={index}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </>
                ) : (
                  ""
                )}
              </div>
              <br />

              <div className="">
                <h2>8. WHAT IS YOUR AVERAGE ELECTRICAL SPEND PER MONTH</h2>
                <p>
                  Electrical spend average:<div className="required">*</div>{" "}
                </p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.avgElec}
                  onChange={handleAvgElecChange}
                  required
                >
                  {avgElec.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <br />
              </div>
              <br />
            </div>
          )}
          <br />

          <br />

          {/* <div className="loadRequired">
          <h2>5. LOAD REQUIRED</h2>
          <h5>(Essential load you would like to add to your system)</h5>
          <h4>Essential Items</h4>
          <hr />
          <div className="essential1">
            <p>5.1 Tv & Wifi:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.tvWifiOption}
              onChange={handleTvWifiOptionChange}
              // required
            >
              {tvWifiOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />

            <p>5.2 Microwave:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.microwaveOption}
              onChange={handleMicrowaveOptionChange}
              // required
            >
              {microwaveOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
            {questionnaire.tvWifiOption === "Yes" ||
            questionnaire.microwaveOption === "Yes" ? (
              <div>
                <p>Total Wattage: (in Watts)</p>
                <input
                  className="input"
                  type="number"
                  value={questionnaire.tvMicrowaveTotalWattage || ""}
                  onChange={handleChange("tvMicrowaveTotalWattage")}
                  // required
                ></input>
              </div>
            ) : (
              ""
            )}
          </div>

          <br />
          <hr />

          <div className="essential2">
            <p>5.3 Fridge:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.fridgeOption}
              onChange={handleFridgeOptionChange}
              // required
            >
              {fridgeOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />

            {questionnaire.fridgeOption === "Yes" ? (
              <div>
                <p>Number of fridges & freezers:</p>
                <select
                  className="dropdown"
                  type="dropdown"
                  name="offerDropdown"
                  value={questionnaire.numFridge}
                  onChange={handleNumFridgeChange}
                  // required
                >
                  {numFridge.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <p>Total Wattage: (in Watts)</p>
                <input
                  className="input"
                  type="number"
                  value={questionnaire.fridgeTotalWattage || ""}
                  onChange={handleChange("fridgeTotalWattage")}
                  // required
                ></input>
              </div>
            ) : (
              ""
            )}
          </div>

          <br />
          <hr />

          <div className="essential3">
            <p>5.4 Lights: (reccomended to be LED)</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.lightsOption}
              onChange={handleLightsOptionChange}
              // required
            >
              {lightsOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
            {questionnaire.lightsOption === "Yes" ? (
              <div>
                <p>Total Wattage: (in Watts)</p>
                <input
                  className="input"
                  type="number"
                  value={questionnaire.lightsTotalWattage || ""}
                  onChange={handleChange("lightsTotalWattage")}
                  // required
                ></input>
              </div>
            ) : (
              ""
            )}
          </div>

          <br />
          <hr />

          <div className="essential4">
            <p>5.5 Gate Motor:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.gateMotorOption}
              onChange={handleGateMotorOptionChange}
              // required
            >
              {gateMotorOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
            {questionnaire.gateMotorOption === "Yes" ? (
              <div>
                <p>Total Wattage: (in Watts)</p>
                <input
                  className="input"
                  type="number"
                  value={questionnaire.gateMotorTotalWattage || ""}
                  onChange={handleChange("gateMotorTotalWattage")}
                  // required
                ></input>
              </div>
            ) : (
              ""
            )}
          </div>

          <br />
          <hr />

          <div className="essential5">
            <p>5.6 Alarm System: (Incl Electric Fencing)</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.alarmSystemOption}
              onChange={handleAlarmSystemOptionChange}
              // required
            >
              {alarmSystemOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
            {questionnaire.alarmSystemOption === "Yes" ? (
              <div>
                <p>Total Wattage: (in Watts)</p>
                <input
                  className="input"
                  type="number"
                  value={questionnaire.alarmSystemTotalWattage || ""}
                  onChange={handleChange("alarmSystemTotalWattage")}
                  // required
                ></input>
              </div>
            ) : (
              ""
            )}
          </div>

          <br />
          <hr />

          <div className="essential6">
            <p>5.7 Camera System:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.cameraSystemOption}
              onChange={handleCameraSystemOptionChange}
              // required
            >
              {cameraSystemOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
            {questionnaire.cameraSystemOption === "Yes" ? (
              <div>
                <p>Total Wattage: (in Watts)</p>
                <input
                  className="input"
                  type="number"
                  value={questionnaire.cameraSystemTotalWattage || ""}
                  onChange={handleChange("cameraSystemTotalWattage")}
                  // required
                ></input>
              </div>
            ) : (
              ""
            )}
          </div>

          <br />
          <h4>Non-Essential Items</h4>
          <hr />

          <div className="non-essential1">
            <p>5.8 Type of Stove:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.stoveType}
              onChange={handleStoveTypeChange}
              // required
            >
              {stoveType.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          <br />
          <hr />

          <div className="non-essential2">
            <p>5.9 Type of Hob:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.hobType}
              onChange={handleHobTypeChange}
              // required
            >
              {hobType.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          <br />
          <hr />

          <div className="non-essential3">
            <p>5.10 Number of Geysers:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.numGeysers}
              onChange={handleNumGeysersChange}
              // required
            >
              {numGeysers.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          <br />
          <hr />

          <div className="non-essential4">
            <p>5.11 Type of Kettle:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.kettleType}
              onChange={handleKettleTypeChange}
              // required
            >
              {kettleType.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          <br />
          <hr />

          <div className="non-essential5">
            <p>5.12 Freezers:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.numFreezers}
              onChange={handleNumFreezersChange}
              // required
            >
              {numFreezers.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
            {questionnaire.numFreezers !== "" ? (
              <div>
                <p>Total Wattage: (in Watts)</p>
                <input
                  className="input"
                  type="number"
                  value={questionnaire.freezerTotalWattage || ""}
                  onChange={handleChange("freezerTotalWattage")}
                  // required
                ></input>
              </div>
            ) : (
              ""
            )}
          </div>

          <br />
          <hr />

          <div className="non-essential6">
            <p>5.13 Pool Motor:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.poolMotorOption}
              onChange={handlePoolMotorOptionChange}
              // required
            >
              {poolMotorOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          {questionnaire.poolMotorOption === "Yes" ? (
            <div>
              <p>Total Wattage: (in Watts)</p>
              <input
                className="input"
                type="number"
                value={questionnaire.poolMotorTotalWattage || ""}
                onChange={handleChange("poolMotorTotalWattage")}
                required
              ></input>
            </div>
          ) : (
            ""
          )}

          <br />
          <hr />

          <div className="non-essential7">
            <p>5.14 Boreholes:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.boreholesOption}
              onChange={handleBoreholesOptionChange}
              // required
            >
              {boreholesOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          {questionnaire.boreholesOption === "Yes" ? (
            <div>
              <p>Total Wattage: (in Watts)</p>
              <input
                className="input"
                type="number"
                value={questionnaire.boreholesTotalWattage || ""}
                onChange={handleChange("boreholesTotalWattage")}
                // required
              ></input>
            </div>
          ) : (
            ""
          )}

          <br />
          <hr />

          <div className="non-essential8">
            <p>5.15 Washing Machine: (total for property)</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.numWashingMachine}
              onChange={handleNumWashingMachineChange}
              // required
            >
              {numWashingMachine.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          {questionnaire.numWashingMachine !== "" ? (
            <div>
              <p>Total Wattage: (in Watts)</p>
              <input
                className="input"
                type="number"
                value={questionnaire.washingMachineTotalWattage || ""}
                onChange={handleChange("washingMachineTotalWattage")}
                // required
              ></input>
            </div>
          ) : (
            ""
          )}

          <br />
          <hr />

          <div className="non-essential9">
            <p>5.16 Dish Washer:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.numDishWasher}
              onChange={handleNumDishWasherChange}
              // required
            >
              {numDishWasher.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          {questionnaire.numDishWasher !== "" ? (
            <div>
              <p>Total Wattage: (in Watts)</p>
              <input
                className="input"
                type="number"
                value={questionnaire.dishWasherTotalWattage || ""}
                onChange={handleChange("dishWasherTotalWattage")}
                // required
              ></input>
            </div>
          ) : (
            ""
          )}

          <br />
          <hr />

          <div className="non-essential10">
            <p>5.17 Underfloor Heating:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.floorHeatingOption}
              onChange={handleFloorHeatingOptionChange}
              // required
            >
              {floorHeatingOption.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          {questionnaire.floorHeatingOption === "Yes" ? (
            <div>
              <p>Total Wattage: (in Watts)</p>
              <input
                className="input"
                type="number"
                value={questionnaire.floorHeatingTotalWattage || ""}
                onChange={handleChange("floorHeatingTotalWattage")}
                // required
              ></input>
            </div>
          ) : (
            ""
          )}

          <br />
          <hr />

          <div className="non-essential10">
            <p>5.18 Airconditioners:</p>
            <select
              className="dropdown"
              type="dropdown"
              name="offerDropdown"
              value={questionnaire.numAirCon}
              onChange={handleNumAirConChange}
              // required
            >
              {numAirCon.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.label}
                </option>
              ))}
            </select>
            <br />
          </div>

          {questionnaire.numAirCon !== "" ? (
            <div>
              <p>Total Wattage: (in Watts)</p>
              <input
                className="input"
                type="number"
                value={questionnaire.airConTotalWattage || ""}
                onChange={handleChange("airConTotalWattage")}
                // required
              ></input>
            </div>
          ) : (
            ""
          )}
        </div> */}

          <br />

          {/* <div className='db'>
                            <h4>PLEASE SUPPLY AN IMAGE OF YOUR DISTRIBUTION BOARD</h4>
                            <p>Upload:</p>
                            {
                                files.length > 0 ? 
                                files.map((x,i)=>{
                                return(
                                <>
                                <div key={i}>
                                    {
                                    <a href={(x.base64)} download={x.name}> {x.name} </a> 
                                    }
                                </div>
                                <div>
                                {
                                    files.length - 1 === i && 
                                    <div className="row date-style">
                                        <FileBase64
                                            multiple={ false }
                                            onDone={ (e)=> handleAddFiles(e) } />
                                    </div>
                                }
                                </div>
                                </>
                                )
                                }) :
                                <FileBase64
                                multiple={ false }
                                onDone={ (e)=> getFiles(e) } />
                                
                            }
                            <br/>
                        </div> */}

          {message === "Submitting questionnaire..." ? (
            <h2 className="bstyle"> Submitting questionnaire...</h2>
          ) : message === "questionnaire submitted successfully" ? (
            <div>
              {message.split("\n").map((e) => (
                <p>{e}</p>
              ))}
            </div>
          ) : (
            <div>
              <br />
              <br />
              <br />
              <center>
                <CustomButton type="submit"> Submit </CustomButton>
              </center>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default QuestionnaireFormComponent;
